import { useQueries } from "react-query";
import { getUserByAccountId } from "../../api/confluence-api";
import { useEffect, useState } from "react";
import { createProfileLink } from "../../helpers/cosmos-profile-link";

export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export const localizeDate = (date, locale) => {
  return new Date(date).toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export async function getBlogById(contentId) {
  const url = `/rest/api/search?cql=type=blogpost and id=${contentId}&limit=1&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch blogpost", contentId);
    console.log(e);
    return undefined;
  }
}

export async function getSpaceByKey(spaceKey) {
  try {
    return window.AP.request(
      `/api/v2/spaces?keys=${spaceKey}&include-icon=true&description-format=plain`
    );
  } catch (error) {
    return undefined;
  }
}

export const mapSpace = (space, locale, isCosmosInstalled) => ({
  icon: space.icon,
  name: space.name,
  spaceKey: space.key,
  description: space.description.plain.value,
  // createdBy: space.history.createdBy.displayName,
  authorUrl: isCosmosInstalled
    ? createProfileLink(space.authorId)
    : `${window.AP._hostOrigin}/wiki/people/${space.authorId}`,
  creatorId: space.authorId,
  // permissions: space.permissions.filter(
  //         (permission) => permission.operation.targetType === "space" && permission.operation.operation === "administer",
  //             ),
  // )
  type: "space",
  // labels: space?.metadata?.labels?.results
  //   ? space.metadata.labels.results.filter((l) => l.prefix !== "my").map((l) => l.label)
  //   : [],
  value: space.key,
  url: `${window.AP._hostOrigin}/wiki/spaces/${space.key}/overview`,
  homepageId: space.homepageId,
});

export const useSpaces = (data, isCosmosInstalled) =>
  useQueries(
    data.map((space) => {
      return {
        queryKey: ["space", space.spaceKey, space.id],
        queryFn: () => {
          if (!space.spaceKey) {
            return { isNew: true, loading: false, id: space.id };
          }
          return getSpaceByKey(space.spaceKey);
        },
        retry: 0,
        placeholderData: {
          spaceKey: space.spaceKey,
          spaceId: space.spaceId,
          loading: true,
          isPlaceholder: true,
        },
        select: (response) => {
          if (response.isPlaceholder || response.isNew) {
            return response;
          }
          const { results } = JSON.parse(response.body);
          const result = results[0];
          return {
            ...mapSpace(result, isCosmosInstalled),
            id: data.find((x) => x.id.toString() === space.id).id,
            backgroundImage: data.find((x) => x.id.toString() === space.id)
              .backgroundImage,
            overlay: data.find((x) => x.id.toString() === space.id).overlay,
            backgroundColor: data.find((x) => x.id.toString() === space.id)
              .backgroundColor,
          };
        },
      };
    })
  );

export function useUserNamesFromSpaces(spacesData) {
  const [userNames, setUserNames] = useState({});

  useEffect(() => {
    async function fetchUserNames() {
      const userIds = new Set();

      Object.values(spacesData || {})
        .flat()
        .forEach((space) => {
          const userId = space?.creatorId;

          if (userId && !userNames[userId]) {
            userIds.add(userId);
          }
        });

      if (userIds.size === 0) return;
      const newNames = {};
      await Promise.all(
        [...userIds].map(async (id) => {
          try {
            const user = await getUserByAccountId(id);
            const userData = JSON.parse(user.body);

            newNames[id] = userData?.displayName || "Unknown User";
          } catch {
            newNames[id] = "Unknown User";
          }
        })
      );
      setUserNames((prev) => ({ ...prev, ...newNames }));
    }

    fetchUserNames();
  }, [spacesData]);

  return userNames;
}
